import Controller from "csi/action/Controller";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";

// Action Ids
const RESET_INGREDIENTS = "ResetIngredients";
const REFRESH_ALLERGENS = "RefreshAllergens";
const REFRESH_NUTRIENTS = "RefreshNutrients";
const REFRESH_CLAIMS = "RefreshClaims";

// Valid States
const DRAFT = "Revision.State:DRAFT";
const PENDING = "Revision.State:PENDING";
const APPROVED = "Revision.State:APPROVED";

const RefreshLabelItemsController = declare(Controller, {

	refreshFromBOMRevisionURL: null,

	/**
     * @override
     * If there is no valid revision to refresh from:
     * Warn and ask the user wether to refresh from the revision referenced by CopiedFromBomRev
     */
	preProcess: function() {
		this.getLatestValidRecipeRevision();
		if (!this.refreshFromBOMRevisionURL) {
			this.refreshFromBOMRevisionURL = this.getParent().CopiedFromBOMRev;
			this.confirmAction({});
		} else {
			this.inherited(arguments);
		}
	},

	/**
     * @override
     * Find the latest valid revision to refresh from (valid => draft, pending, approved)
     */
	getLatestValidRecipeRevision: function() {
		const ctx = this.getContext();
		const copiedFromBomNode = ctx.cache.getPathNode(this.getParent(), "Child:__Parent__/Child:CopiedFromBOM");
		copiedFromBomNode.Revisions.forEach((bomRevisionURL) => {
			const bomRevState = ctx.cache.getNode(bomRevisionURL, true).State;
			if (bomRevState == DRAFT || bomRevState == PENDING || bomRevState == APPROVED) {
				this.refreshFromBOMRevisionURL = bomRevisionURL;
			}
		});
	},

	onConfirm: function(key) {
		if (key == MessageDialog.BUTTON_CONTINUE) {
			this.process();
		} else {
			this.postProcess();
		}
	},

	confirmAction: function(params) {
		const ctx = this.getContext();
		const refreshFromBOMRevision = ctx.cache.getNode(this.refreshFromBOMRevisionURL, true);
		const refreshFromBOM = ctx.cache.getNode(refreshFromBOMRevision.__Parent__, true);
        
		const bomType = locale.type(refreshFromBOM.$Type);
		const bomName = refreshFromBOM["Node Name"];
		const revisionNumber = refreshFromBOMRevision["Node Name"];
		const stateEnumText = xml.enumGetText(refreshFromBOMRevision.State);
		const actionName = locale.resource(this.getContext().ac.m_action.m_id);

		params.title = actionName;
		params.message = locale.resource("RefreshFromInvalidRevision_Warning", [
			bomName,
			revisionNumber,
			stateEnumText.toLowerCase(),
			actionName.split(" ")[0].toLowerCase(),
		]);
		params.buttons = [MessageDialog.BUTTON_CONTINUE, MessageDialog.BUTTON_CANCEL];

		this.inherited(arguments);
	},

	/**
     * @override
     * Add Parameter URL (FoodLabelDataSheet to refresh)
     * Add Parameter RecipeRev (revision to refresh from)
     * Set boolean params based on which action is called
     */
	toWriterRequest: function() {
		const action = this.getContext().ac.m_action.m_id;
		const call = this.inherited<CallMethod>(arguments);
		const FoodLabelUrl = this.getParent().__Parent__;
		call.addParameter("URL", xml.ATTR_REF, FoodLabelUrl);
		call.addParameter("FromURL", xml.ATTR_REF, this.refreshFromBOMRevisionURL);
		call.addParameter("Ingredients", xml.ATTR_BOOLEAN, action == RESET_INGREDIENTS);
		call.addParameter("Allergens", xml.ATTR_BOOLEAN, action == REFRESH_ALLERGENS);
		call.addParameter("Nutrients", xml.ATTR_BOOLEAN, action == REFRESH_NUTRIENTS);
		call.addParameter("Claims", xml.ATTR_BOOLEAN, action == REFRESH_CLAIMS);
		return call;
	},
});

export = RefreshLabelItemsController;